<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem3">
				<div class="left">
					<div :lazy-background="item.img" class="img"></div>
				</div>
				<div class="right">
					<div class="contentContainer">
						<div class="textHidden">
							<div class="header">
								{{item.header}}
							</div>
							<div class="text">
								{{item.text}}
							</div>
						</div>
						<div>
							<a :href="item.href" class="button waves-effect waves-light">{{item.button}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: true,
				margin: 30
			}
		});
	},
	mounted() {
		lazyBackground();
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.slider-lastProject {
	margin-bottom: 85px;
	b{
		font-weight: 900;
	}
	.owl-carousel {
		position: relative;
		padding-bottom: 70px;
		.owl-stage-outer{
			padding: 0 1px;
		}
		.item {
			.containerItem3{
				display: flex;
				flex-direction: column;
				@include m___up{
					flex-direction: row;
				}
				& > *{
					width: 100%;
				}
				.left{
					border-radius: 8px;
					position: relative;
					overflow: hidden;
					height: 305px;
					@include l_up{
						height: 305px;
					}
					@include l__up{
						min-width: 519px;
					};
					.img{
						margin: 2px;
						position: absolute;
						top: 0;
						bottom: 0;
						left: 0;
						right: 0;
						margin: 0 auto;
						width: 100%;
						height: 100%;
						background-position: center;
						background-size: cover;
						border-radius: 8px;
					}
				}
				.right{
					padding-left: 0px;
					padding-top: 30px;
					@include m___up{
						padding-left: 28px;
						padding-top: 0px;
						&:after{
							top: calc(50% - 9px);
							left: -12px;
						}
					}
					.contentContainer{
						padding: 23px 30px 34px;
						border: 1px solid #e2edf3;
						margin: 2px;
						border-radius: 8px;
						position: relative;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						@include m___up{
							height: 305px;
						}
						.textHidden{
							height: 245px;
							overflow: hidden;
							@include s___up{
								height: 200px
							}
							@include m___up{
								height: 150px;
								overflow: hidden;
							}
							.header{
								font-weight: 900;
								font-size: rem(15);
								line-height: rem(24);
								margin-bottom: 21px;
								color: #000000;
							}
							.text{
								line-height: rem(20);
							}
						}
						&:after{
							content: "";
							position: absolute;
							top: -12px;
							left: calc(50% - 6px);
							width: 12px;
							height: 18px;
							background-image: url('../img/arrow.jpg');
							background-size: cover;
							transform: rotate(90deg);
							@include m___up{
								left: -10px;
								top: calc(50% - 9px);
								transform: rotate(0deg);
							}
						}
					}
				}
				.button{
					width: 190px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// lastProject.vue?34a7fb8c